import {
  AppBar,
  Typography,
  Button,
  Menu,
  MenuItem,
  List,
  ListItemButton,
  ListItemText,
  ListItemAvatar,
  ListItemIcon,
  Avatar,
  Dialog,
  DialogTitle,
  Box,
  IconButton,
  Divider,
} from '@mui/material';
import {
  AccountBalanceWalletOutlined,
  BuildOutlined,
  Close,
  EmojiEventsOutlined,
  Menu as MenuIcon,
  SportsEsportsOutlined,
} from '@mui/icons-material';
import { FaDiscord, FaSignOutAlt } from 'react-icons/fa';
import { getAddress } from 'sats-connect';
import { useUnityContext } from 'react-unity-webgl';
import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setLogin, setLogout } from 'state';
import { useLocation, useNavigate } from 'react-router-dom';
import ReactGA from 'react-ga';
import { serverEnvironment } from 'configs/app-config.js';
import { AppConfig, UserSession, showConnect } from '@stacks/connect';
import { StacksMainnet } from '@stacks/network';
import WarningDialog from '../../components/warningDialog';
import { ethers } from 'ethers';
import { V2ContentToolbar } from 'features/v2/V2ContentContainer';

const PixelPlayMark = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    style={{ imageRendering: 'pixelated', display: 'block' }}
  >
    <path d="M1 1h4v1H1zM1 2h1v12H1zM1 14h4v1H1z" fill="#1B2F6F" />
    <path d="M5 2h2v1H5zM7 3h2v1H7zM9 4h2v1H9zM11 5h2v1h-2zM13 6h2v1h-2zM14 7h2v2h-2zM13 9h2v1h-2zM11 10h2v1h-2zM9 11h2v1H9zM7 12h2v1H7zM5 13h2v1H5z" fill="#1B2F6F" />
    <path d="M2 2h1v6H2zM3 2h1v6H3zM4 2h1v6H4zM5 3h1v5H5zM6 3h1v5H6zM7 4h1v4H7zM8 4h1v4H8zM9 5h1v3H9zM10 5h1v3h-1zM11 6h1v2h-1zM12 6h1v2h-1zM13 7h1v1h-1z" fill="#5ECAFF" />
    <path d="M3 2h1v6H3z" fill="#CAEFFF" />
    <path d="M2 8h12v1H2zM2 9h11v1H2zM2 10h9v1H2zM2 11h7v1H2zM2 12h5v1H2zM2 13h3v1H2z" fill="#3EA6FF" />
  </svg>
);

const navigationItems = [
  { label: 'Dashboard', path: '/', icon: SportsEsportsOutlined },
  { label: 'Leaderboard', path: '/leaderboard', icon: EmojiEventsOutlined },
  { label: 'Inscription Sandbox', path: '/inscription-sandbox', icon: BuildOutlined },
];

const Navbar = () => {
  const dispatch = useDispatch();
  const { addEventListener, removeEventListener } = useUnityContext({
    loaderUrl: 'Build/build_test_webgl.loader.js',
    dataUrl: 'Build/build_test_webgl.data',
    frameworkUrl: 'Build/build_test_webgl.framework.js',
    codeUrl: 'Build/build_test_webgl.wasm',
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const [openConnectWalletDialog, setOpenConnectWalletDialog] = useState(false);
  const [openWarningDialog, setOpenWarningDialog] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const user = useSelector((state) => state.user);
  const ordinalAddress = (user && user.ordinalAddress) || ''; //useSelector((state) => state.user.ordinalAddress);
  const ethAddress = (user && user.ethAddress) || ''; //useSelector((state) => state.user.ordinalAddress);
  const walletAddress = ordinalAddress || ethAddress;
  // const ordinalAddress = useSelector((state) => state.ordinalAddress);
  // const paymentAddress = useSelector((state) => state.paymentAddress);
  const wallets = [
    {
      name: 'Xverse',
      image: '/assets/xverse.png',
      description: 'Bitcoin wallet for Ordinals',
    },
    {
      name: 'Metamask',
      image: '/assets/metamask.png',
      description: 'Ethereum wallet connection',
    },
  ];

  // Hiro wallet
  const userSession = React.useMemo(() => {
    const appConfig = new AppConfig();
    return new UserSession({ appConfig });
  }, []);

  const navigate = useNavigate();
  const location = useLocation();
  const open = Boolean(anchorEl);
  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
    ReactGA.event({
      category: 'button_click',
      action: 'signed_connect_button_click',
      label: 'SignedConnectButtonClick',
    });
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const isNavigationActive = (path) => {
    if (path === '/') {
      return location.pathname === '/' || location.pathname.startsWith('/games/');
    }
    return location.pathname === path;
  };

  const handleNavigation = (path) => {
    setMobileMenuOpen(false);
    navigate(path);
  };

  // Get Wallet addresses from wallets
  const handleGetAddress = useCallback(
    async (walletName) => {
      const registerUser = async (ordinalAddress, paymentAddress) => {
        await fetch(`${serverEnvironment}/auth/login`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            ordinalAddress,
            paymentAddress,
          }),
        })
          .then(async (data) => {
            const response = await data.json();
            // onSignMessageClick(response.user.ordinalAddress, 'from register');
            dispatch(setLogin({ user: response.user }));
          })
          .catch((err) => console.error(err));
      };

      const registerEthUser = async (ethAddress) => {
        await fetch(`${serverEnvironment}/auth/login`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            ethAddress,
          }),
        })
          .then(async (data) => {
            const response = await data.json();
            // onSignMessageClick(response.user.ordinalAddress, 'from register');
            dispatch(setLogin({ user: response.user }));
          })
          .catch((err) => console.error(err));
      };

      const getAddressOptions = {
        payload: {
          purposes: ['ordinals', 'payment'],
          message: 'Address for receiving Ordinals and payments',
          network: {
            type: 'Mainnet',
          },
        },
        onFinish: (response) => {
          // dispatch(
          //   setAddresses({
          //     ordinalAddress: response.addresses[0].address,
          //     paymentAddress: response.addresses[1].address,
          //   })
          // );
          registerUser(
            response.addresses[0].address,
            response.addresses[1].address
          );
        },
      };

      if (walletName === 'Xverse') {
        await getAddress(getAddressOptions);
      } else if (walletName === 'Hiro Wallet') {
        var resolve = (paymentAddress, ordinalAddress) => {
          // dispatch(
          //   setAddresses({
          //     ordinalAddress,
          //     paymentAddress,
          //   })
          // );
          registerUser(ordinalAddress, paymentAddress);
        };

        if (!userSession.isUserSignedIn()) {
          showConnect({
            userSession,
            network: StacksMainnet,
            appDetails: {
              name: 'Ordinals Play',
              icon: 'https://firebasestorage.googleapis.com/v0/b/ordinalsplay-ef807.appspot.com/o/ordinals_play_logo_no_text.png?alt=media&token=6f61113c-bcba-45fd-bf33-bfb8b3bb7e8b',
            },
            onFinish: () => {
              resolve(
                userSession.loadUserData().profile.btcAddress.p2wpkh.mainnet,
                userSession.loadUserData().profile.btcAddress.p2tr.mainnet
              );
            },
          });
        }
      } else if (walletName === 'Metamask') {
        if (window.ethereum) {
          async function requestAccount() {
            if (window.ethereum) {
              const message = 'Sign in to Ordinals Play';
              try {
                const provider = new ethers.BrowserProvider(window.ethereum)
                const signer = await provider.getSigner();
                const address = await signer.getAddress();
                await signer.signMessage(message);

                registerEthUser(address);
              } catch (error) {
                console.log('Error connecting...');
              }
            } else {
              alert('Meta Mask not detected');
            }
          }
          await requestAccount();
        }
      }
    },
    [dispatch, userSession]
  );

  // Connect wallet from Unity
  const connectWalletFromUnity = useCallback(async () => {
    ReactGA.event({
      category: 'trigger_unity',
      action: 'connect_wallet',
      label: 'ConnectWallet',
    });
    setOpenConnectWalletDialog(true);
  }, [setOpenConnectWalletDialog]);

  // WalletLogin is the name of the function in React.jslib file in Unity
  useEffect(() => {
    addEventListener('WalletLogin', connectWalletFromUnity);
    return () => {
      removeEventListener('WalletLogin', connectWalletFromUnity);
    };
  }, [addEventListener, removeEventListener, connectWalletFromUnity]);

  // Connect wallet
  const connectWallet = async (walletName) => {
    ReactGA.event({
      category: 'button_click',
      action: 'connect_wallet',
      label: 'ConnectWallet',
    });
    await handleGetAddress(walletName);
    setOpenConnectWalletDialog(false);
  };

  // Sign out
  const signOut = () => {
    setAnchorEl(null);
    dispatch(setLogout());

    if (userSession.isUserSignedIn()) {
      userSession.signUserOut();
    }

    ReactGA.event({
      category: 'button_click',
      action: 'signed_sign_out_click',
      label: 'SignedSignOutClick',
    });
  };

  return (
    <React.Fragment>
      <WarningDialog
        open={openWarningDialog}
        onCloseWarningDialog={() => setOpenWarningDialog(false)}
      />
      <AppBar
        className="v2-navbar"
        position="sticky"
        elevation={0}
        sx={{
          top: 0,
          zIndex: 40,
          color: '#fff',
          borderBottom: '1px solid rgba(255,255,255,0.06)',
          backgroundColor: 'rgba(23,26,33,0.88)',
          backgroundImage: 'none',
          backdropFilter: 'blur(12px)',
        }}
      >
        <V2ContentToolbar
          sx={{
            minHeight: '64px !important',
            display: 'grid',
            gridTemplateColumns: { xs: 'minmax(0, 1fr) auto', md: 'minmax(170px, 1fr) auto minmax(140px, 1fr)' },
            alignItems: 'center',
            columnGap: { xs: 1, md: 1.5, lg: 3 },
          }}
        >
          <Box
            component="button"
            type="button"
            aria-label="Ordinals Play dashboard"
            onClick={() => {
              handleNavigation('/');
              ReactGA.event({
                category: 'routing',
                action: 'logo_click_home_page',
                label: 'LogoClickHomePage',
              });
            }}
            sx={{
              minWidth: 0,
              m: 0,
              p: 0,
              border: 0,
              background: 'transparent',
              color: 'inherit',
              display: 'flex',
              alignItems: 'center',
              gap: 1.5,
              textAlign: 'left',
              cursor: 'pointer',
              borderRadius: '8px',
              '&:focus-visible': {
                outline: '2px solid #F7931A',
                outlineOffset: 3,
              },
            }}
          >
            <Box
              sx={{
                width: 40,
                height: 40,
                flexShrink: 0,
                display: 'grid',
                placeItems: 'center',
                borderRadius: '10px',
                border: '1px solid rgba(62,166,255,0.30)',
                backgroundColor: 'rgba(62,166,255,0.10)',
                boxShadow: '0 0 10px rgba(62,166,255,0.15)',
              }}
            >
              <PixelPlayMark />
            </Box>
            <Box sx={{ minWidth: 0, lineHeight: 1 }}>
              <Typography
                component="span"
                sx={{
                  display: 'block',
                  whiteSpace: 'nowrap',
                  fontSize: { xs: 13, lg: 17 },
                  fontWeight: 800,
                  lineHeight: 1.05,
                  letterSpacing: '-0.02em',
                }}
              >
                ORDINALS <Typography component="span" sx={{ color: '#F7931A', font: 'inherit' }}>PLAY</Typography>
              </Typography>
              <Typography
                component="span"
                sx={{
                  display: 'block',
                  mt: 0.35,
                  whiteSpace: 'nowrap',
                  color: '#A3A3A3',
                  fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',
                  fontSize: { xs: 7.5, lg: 9 },
                  fontWeight: 600,
                  lineHeight: 1,
                  letterSpacing: '0.16em',
                }}
              >
                BITCOIN ARCADE
              </Typography>
            </Box>
          </Box>

          <Box
            component="nav"
            aria-label="Primary navigation"
            sx={{
              display: { xs: 'none', md: 'flex' },
              alignItems: 'center',
              gap: 0.5,
              p: 0.5,
              border: '1px solid rgba(255,255,255,0.05)',
              borderRadius: '10px',
              backgroundColor: 'rgba(255,255,255,0.05)',
            }}
          >
            {navigationItems.map(({ label, path, icon: Icon }) => {
              const active = isNavigationActive(path);
              return (
                <Button
                  key={path}
                  onClick={() => handleNavigation(path)}
                  startIcon={<Icon sx={{ fontSize: { md: 15, lg: 17 } }} />}
                  aria-current={active ? 'page' : undefined}
                  sx={{
                    minWidth: 0,
                    minHeight: 32,
                    px: { md: 1, lg: 1.5 },
                    py: 0.5,
                    border: '1px solid',
                    borderColor: active ? 'rgba(247,147,26,0.20)' : 'transparent',
                    borderRadius: '8px',
                    backgroundColor: active ? 'rgba(247,147,26,0.10)' : 'transparent',
                    color: active ? '#F7931A' : '#A3A3A3',
                    fontSize: { md: 10.5, lg: 12 },
                    fontWeight: active ? 700 : 600,
                    letterSpacing: 0,
                    textTransform: 'none',
                    whiteSpace: 'nowrap',
                    '&:hover': {
                      color: active ? '#F7931A' : '#fff',
                      borderColor: active ? 'rgba(247,147,26,0.20)' : 'transparent',
                      backgroundColor: active ? 'rgba(247,147,26,0.10)' : 'rgba(255,255,255,0.05)',
                    },
                  }}
                >
                  {label}
                </Button>
              );
            })}
          </Box>

          <Box
            sx={{
              display: { xs: 'none', md: 'flex' },
              justifyContent: 'flex-end',
              alignItems: 'center',
              gap: { md: 0.75, lg: 1.25 },
              minWidth: 0,
            }}
          >
            <Button
              onClick={() => navigate('/discord')}
              startIcon={<FaDiscord color="#5865F2" />}
              sx={{
                display: { md: 'none', lg: 'inline-flex' },
                minHeight: 34,
                px: 1.5,
                color: '#D4D4D4',
                border: '1px solid rgba(255,255,255,0.06)',
                backgroundColor: '#171A21',
                fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',
                fontSize: 11,
                textTransform: 'none',
                '&:hover': { backgroundColor: '#1F232C', borderColor: 'rgba(255,255,255,0.10)' },
              }}
            >
              Discord Bot
            </Button>

            {walletAddress ? (
              <Button
                id="wallet-control"
                onClick={handleMenuClick}
                aria-controls={open ? 'wallet-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                startIcon={<AccountBalanceWalletOutlined sx={{ fontSize: 17 }} />}
                sx={{
                  minWidth: 0,
                  minHeight: 34,
                  px: { md: 1.25, lg: 1.5 },
                  color: '#F7931A',
                  border: '1px solid rgba(247,147,26,0.20)',
                  borderRadius: '8px',
                  backgroundColor: 'rgba(247,147,26,0.10)',
                  fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',
                  fontSize: { md: 10, lg: 11 },
                  letterSpacing: 0,
                  textTransform: 'none',
                  whiteSpace: 'nowrap',
                  '&:hover': { backgroundColor: 'rgba(247,147,26,0.18)' },
                }}
              >
                {`${walletAddress.slice(0, 5)}...${walletAddress.slice(-4)}`}
              </Button>
            ) : (
              <Button
                variant="contained"
                onClick={() => setOpenConnectWalletDialog(true)}
                sx={{
                  minHeight: 34,
                  px: { md: 1.25, lg: 2 },
                  borderRadius: '8px',
                  backgroundColor: '#F7931A',
                  color: '#07090D',
                  boxShadow: '0 0 15px rgba(247,147,26,0.30)',
                  fontSize: { md: 10, lg: 11 },
                  whiteSpace: 'nowrap',
                  '&:hover': { backgroundColor: '#FF9F30' },
                }}
              >
                Connect Wallet
              </Button>
            )}
          </Box>

          <IconButton
            aria-label={mobileMenuOpen ? 'Close navigation menu' : 'Open navigation menu'}
            aria-controls="mobile-navigation-panel"
            aria-expanded={mobileMenuOpen}
            onClick={() => setMobileMenuOpen((current) => !current)}
            sx={{
              display: { xs: 'inline-flex', md: 'none' },
              width: 40,
              height: 40,
              color: '#A3A3A3',
              border: '1px solid rgba(255,255,255,0.05)',
              borderRadius: '8px',
              backgroundColor: '#171A21',
              '&:hover': { color: '#fff', backgroundColor: '#1F232C' },
            }}
          >
            {mobileMenuOpen ? <Close /> : <MenuIcon />}
          </IconButton>
        </V2ContentToolbar>

        {mobileMenuOpen && (
          <Box
            id="mobile-navigation-panel"
            sx={{
              display: { xs: 'block', md: 'none' },
              px: 2,
              py: 2,
              borderTop: '1px solid rgba(255,255,255,0.05)',
              backgroundColor: '#171A21',
            }}
          >
            <Box component="nav" aria-label="Mobile primary navigation" sx={{ display: 'grid', gap: 1 }}>
              {navigationItems.map(({ label, path, icon: Icon }) => {
                const active = isNavigationActive(path);
                return (
                  <Button
                    key={path}
                    onClick={() => handleNavigation(path)}
                    startIcon={<Icon />}
                    aria-current={active ? 'page' : undefined}
                    sx={{
                      justifyContent: 'flex-start',
                      minHeight: 44,
                      px: 2,
                      color: active ? '#F7931A' : '#A3A3A3',
                      border: '1px solid',
                      borderColor: active ? 'rgba(247,147,26,0.20)' : 'transparent',
                      borderRadius: '8px',
                      backgroundColor: active ? 'rgba(247,147,26,0.10)' : 'transparent',
                      fontSize: 13,
                      letterSpacing: 0,
                      textTransform: 'none',
                    }}
                  >
                    {label}
                  </Button>
                );
              })}
              <Button
                onClick={() => {
                  setMobileMenuOpen(false);
                  navigate('/discord');
                }}
                startIcon={<FaDiscord color="#5865F2" />}
                sx={{
                  justifyContent: 'flex-start',
                  minHeight: 44,
                  px: 2,
                  color: '#A3A3A3',
                  borderRadius: '8px',
                  fontSize: 13,
                  letterSpacing: 0,
                  textTransform: 'none',
                }}
              >
                Discord Bot
              </Button>
            </Box>

            <Divider sx={{ my: 2, borderColor: 'rgba(255,255,255,0.06)' }} />

            {walletAddress ? (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  gap: 2,
                  p: 1.5,
                  border: '1px solid rgba(255,255,255,0.06)',
                  borderRadius: '10px',
                  backgroundColor: 'rgba(255,255,255,0.04)',
                }}
              >
                <Box sx={{ minWidth: 0 }}>
                  <Typography sx={{ color: '#A3A3A3', fontFamily: 'ui-monospace, monospace', fontSize: 10 }}>
                    Connected wallet
                  </Typography>
                  <Typography noWrap sx={{ mt: 0.25, color: '#fff', fontFamily: 'ui-monospace, monospace', fontSize: 12, fontWeight: 700 }}>
                    {`${walletAddress.slice(0, 5)}...${walletAddress.slice(-4)}`}
                  </Typography>
                </Box>
                <IconButton
                  aria-label="Disconnect wallet"
                  onClick={() => {
                    signOut();
                    setMobileMenuOpen(false);
                  }}
                  sx={{ color: '#A3A3A3', '&:hover': { color: '#F87171', backgroundColor: 'rgba(239,68,68,0.10)' } }}
                >
                  <FaSignOutAlt size={17} />
                </IconButton>
              </Box>
            ) : (
              <Button
                fullWidth
                variant="contained"
                onClick={() => {
                  setMobileMenuOpen(false);
                  setOpenConnectWalletDialog(true);
                }}
                sx={{ minHeight: 44, borderRadius: '8px', backgroundColor: '#F7931A', color: '#07090D', '&:hover': { backgroundColor: '#FF9F30' } }}
              >
                Connect Wallet
              </Button>
            )}
          </Box>
        )}
      </AppBar>

      <Menu
        id="wallet-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{ 'aria-labelledby': 'wallet-control' }}
        PaperProps={{
          sx: {
            mt: 1,
            minWidth: 220,
            color: '#fff',
            border: '1px solid rgba(255,255,255,0.07)',
            borderRadius: '10px',
            backgroundColor: '#171A21',
            backgroundImage: 'none',
            boxShadow: '0 20px 45px rgba(0,0,0,0.45)',
          },
        }}
      >
        <Box sx={{ px: 2, py: 1.25 }}>
          <Typography sx={{ color: '#A3A3A3', fontFamily: 'ui-monospace, monospace', fontSize: 10 }}>
            Connected wallet
          </Typography>
          <Typography sx={{ mt: 0.4, color: '#F7931A', fontFamily: 'ui-monospace, monospace', fontSize: 12, fontWeight: 700 }}>
            {walletAddress ? `${walletAddress.slice(0, 7)}...${walletAddress.slice(-4)}` : ''}
          </Typography>
        </Box>
        <Divider sx={{ borderColor: 'rgba(255,255,255,0.06)' }} />
        <MenuItem onClick={signOut} sx={{ py: 1.25, color: '#D4D4D4', '&:hover': { backgroundColor: 'rgba(255,255,255,0.05)' } }}>
          <ListItemIcon sx={{ color: '#A3A3A3' }}>
            <FaSignOutAlt size={17} />
          </ListItemIcon>
          <ListItemText primary="Disconnect" />
        </MenuItem>
      </Menu>

      <Dialog
        open={openConnectWalletDialog}
        onClose={() => setOpenConnectWalletDialog(false)}
        PaperProps={{
          sx: {
            width: 'calc(100% - 32px)',
            maxWidth: 480,
            m: 2,
            color: '#fff',
            border: '1px solid rgba(255,255,255,0.08)',
            borderRadius: '12px',
            backgroundColor: '#0B0E14',
            backgroundImage: 'none',
            boxShadow: '0 25px 60px rgba(0,0,0,0.55)',
          },
        }}
      >
        <DialogTitle sx={{ px: 3, pt: 3, pb: 1 }}>
          <Typography component="span" sx={{ display: 'block', fontSize: 20, fontWeight: 800 }}>
            Connect Web3 Wallet
          </Typography>
          <Typography component="span" sx={{ display: 'block', mt: 0.5, color: '#A3A3A3', fontFamily: 'ui-monospace, monospace', fontSize: 11 }}>
            Select a supported wallet
          </Typography>
        </DialogTitle>
        <List sx={{ px: 2, pb: 2.5, bgcolor: 'transparent' }}>
          {wallets &&
            wallets.map((wallet) => (
              <React.Fragment key={wallet.name}>
                <ListItemButton
                  onClick={() => connectWallet(wallet.name)}
                  sx={{
                    mb: 1,
                    p: 2,
                    border: '1px solid rgba(255,255,255,0.07)',
                    borderRadius: '10px',
                    backgroundColor: 'rgba(255,255,255,0.035)',
                    '&:hover': {
                      borderColor: 'rgba(247,147,26,0.30)',
                      backgroundColor: 'rgba(255,255,255,0.06)',
                    },
                  }}
                >
                  <ListItemAvatar sx={{ minWidth: 56 }}>
                    <Avatar alt="" src={wallet.image} variant="rounded" sx={{ width: 42, height: 42, bgcolor: '#171A21' }} />
                  </ListItemAvatar>
                  <ListItemText
                    primary={wallet.name}
                    secondary={wallet.description}
                    primaryTypographyProps={{
                      color: '#fff',
                      fontSize: 14,
                      fontWeight: 700,
                    }}
                    secondaryTypographyProps={{ color: '#A3A3A3', fontSize: 11, mt: 0.25 }}
                  />
                </ListItemButton>
              </React.Fragment>
            ))}
        </List>
      </Dialog>
    </React.Fragment>
  );
};

export default Navbar;
